(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/eid-sign/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/app/eid-sign/assets/javascripts/prescript.js');
"use strict";


const prescript = svs => {
  'use strict';

  svs = svs || {};
  svs.app = svs.app || {};
  svs.app.eidSign = svs.app.eidSign || {};
  svs.app.eidSign.logger = svs.app.eidSign.logger || svs.core.log.getLogger('app:eid');
  svs.app.eidSign.bankid = svs.app.eidSign.bankid || {};
  svs.app.eidSign.freja = svs.app.eidSign.freja || {};

  svs.app.eidSign.constants = {
    MODE: {
      BANKID: 'bankid',
      FREJA: 'frejaeid'
    }
  };

  svs.app.eidSign.bankid.constants = {
    CUSTOMER_IDENTIFY_TIMEOUT: 49,
    CUSTOMER_SCAN_TIMEOUT: 56,
    INITIAL_QRCODE_RETRIES: 1 
  };

  svs.app.eidSign.freja.constants = {
    AUTHREF_NOT_FOUND_OR_EXPIRED: 71,
    INITIAL_QRCODE_RETRIES: 1 
  };
};
prescript(svs);

 })(window);